<template>
    <div class="dropdown-menu p-0 dpMenu" style="width: 400px;">
        <div class="cropspage__items__dropdown">
            <div class="closeItem">
                <a href="#">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                    fill="#959595" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                    fill="#959595" />
                </svg>
                </a>
            </div>
            <div class="row">
                <h4 class="font-bold font-sm margin_top_md caps_upper">Farm Location</h4>
            </div>
            <div class="row">
                <div class="col-4 pr-2 pl-0">
                    <label class="checkbox-inline control-label">
                        <input type="checkbox" class="checkbox" v-model="checked" @change="checkAll">
                        <span class="label_title">All</span>
                    </label>
                </div>
                <div class="col-4 pr-2 pl-0" v-for="(st, index) in states" :key="index">
                    <label class="checkbox-inline control-label">
                        <location-row :state="st" @stateValue="stateValue" :selectAll="checked" />
                        
                    </label>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import LocationRow from './LocationRow';
export default {
    data() {
        return {
            checked: '',
            values: [],
        }
    },
    computed: {
        ...mapState(['states'])
    },
    methods: {
        stateValue(value) {
            
            if(this.values.includes(value)) {
                const index = this.values.findIndex(item => item === value)
                this.values.splice(index, 1)
            } else {
                this.values.push(value)
            }
            this.$emit('locationValues', this.values)
        },
        checkAll() {
            if(this.checked) {
                this.values = this.states.map(item => item.id)
            } else {
                this.values = []
            }
            this.$emit('locationValues', this.values)
        },
    },
    components: {
        LocationRow
    }
}
</script>

<style>

</style>